import $ from 'jquery';
import Router from 'biogas/router.js';
import Datatable from 'biogas/datatable.js';
import {numberWithCommas} from 'biogas/clearing.js';
import {GASTYPES} from '../../../constants.js';

export default (function () {
    var periodid;
    var cid;
    var tbls = {};  
    var Clearing;  

    function printamount(key, data) {
        return numberWithCommas(data[key]) + ' kg';
    }

    function recomputeVerbrauch()
    {
        var tbl = ['tankstelle', /* disable for now: 'fluessigtankstelle',*/ 'upgrade', 'heizgas', 'enaw', 'muken', 'strom'];
        var tot = {};

        for (let i = 0; i < GASTYPES.length; i++) {
            tot[GASTYPES[i]] = 0;
            for (var j = 0; j < tbl.length; j++) {
                var sel = '#' + tbl[j] + ' .totalline .' + GASTYPES[i];
                var a = $(sel).attr('data-amount');
                if (a) {
                    tot[GASTYPES[i]] += parseInt(a);
                }
            }
            $('#totalamount .verbrauch-' + GASTYPES[i]).attr('data-amount', tot[GASTYPES[i]]);
            $('#totalamount .verbrauch-' + GASTYPES[i]).html(numberWithCommas(tot[GASTYPES[i]]));
        }
        Clearing.recomputeSummary();
    }

    function recomputeAndToggle(data, wrapper) {
      if (data && data.length) {
        wrapper.removeClass('nn');
        Clearing.recomputeTotal3(wrapper.find('table'));
        recomputeVerbrauch();
      } else {
        wrapper.addClass('nn');
      }
    }

    function setupTankstelle(baseurl, periodid) {
        var modelTankstelle = {
            rowLabel: "setupTankstelle",
            patchurl: '/api/v1/companies/' + cid + '/tankstellen/',
            name: { key: 'name', valCol: 'tid' },
            totalamount: { key: 'totalamount', type: 'number', cssclass: 'amount', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'totalamount', edit: 1 },
            BIOG: { key: 'BIOG', type: 'number', cssclass: 'amount', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'BIOG', edit: 1 },
            H: { key: 'H', type: 'number', cssclass: 'amount', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'H', edit: 1 },
            SG: { key: 'SG', type: 'number', cssclass: 'amount', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'SG', edit: 1 },
            erdgas: { key: 'erdgas', cssclass: 'amount' },
            LBGM: { key: 'LBGM', type: 'number', cssclass: 'amount', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'LBGM', edit: 1},
            LHM: { key: 'LHM', type: 'number', cssclass: 'amount', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'LHM', edit: 1},
            LSGM: { key: 'LSGM', type: 'number', cssclass: 'amount', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'LSGM', edit: 1},
            comment: { key: 'comment', type: 'textarea', update: Clearing.updateElement, valCol: 'comment', edit: 1 },
            actions: { key: 'actions', template: $("#saveform").html() },
            empty: { key: 'empty', template: ' ' },                
            recompute: function () {
                Clearing.recomputeTotal3($("#tankstelle table"));
                recomputeVerbrauch();
            }
        };
        
        var colsTankstelle = [
            'name',
            'totalamount',
            'BIOG',
            'H',
            'SG',
            'LBGM',
            'LHM',
            'LSGM',
            'erdgas',
            'comment',
            'actions'
        ];
        
        var ttbl = new Datatable();
        ttbl.init("#tankstelle table", {
            url: baseurl + '/companies/' + cid + '/periods/' + periodid + '/tankstellen',           
            bodysel: '.datacontent',
            idcol: 'id',
            columns: colsTankstelle,
            model: modelTankstelle,
            okbutton: $("#okbutton").html(),
            datahandler: function (data) {
                // called after data loaded       
                recomputeAndToggle(data, $('#tankstelle'));
            }
        });
        return ttbl;
    }

    function setupFluessigtankstelle(baseurl, periodid) {
        var model = {
            rowLabel: "setupFluessigtankstelle",
            patchurl: '/api/v1/companies/' + cid + '/fluessigtankstellen/',
            name: { key: 'name', valCol: 'tid' },
            //LBGTF: { key: 'LBGTF', type: 'number', cssclass: 'amount', update: Clearing.updateElement, template: printamount, valCol: 'LBGTF', edit: 1 },
            comment: { key: 'comment', type: 'textarea', update: Clearing.updateElement, valCol: 'comment', edit: 1 },
            actions: { key: 'actions', template: $("#saveform").html() },
            empty: { key: 'empty', template: ' ' },
            recompute: function () {
                Clearing.recomputeTotal3($("#fluessigtankstelle table"));
                recomputeVerbrauch();
            }
        };

        var cols = [
            'name',
            //'LBGTF',
            'comment',
            'actions'
        ];

        var ttbl = new Datatable();
        ttbl.init("#fluessigtankstelle table", {
            url: baseurl + '/companies/' + cid + '/periods/' + periodid + '/fluessigtankstellen',
            bodysel: '.datacontent',
            idcol: 'id',
            columns: cols,
            model: model,
            okbutton: $("#okbutton").html(),
            datahandler: function (data) {
                // called after data loaded
                recomputeAndToggle(data, $('#fluessigtankstelle'));
            }
        });
        return ttbl;
    }

    function setupUpgrade(baseurl, periodid) {
        var model = {
            rowLabel: "setupUpgrade",
            patchurl: '/api/v1/companies/' + cid + '/upgrades/',
            name: { key: 'name', valCol: 'tid' },
            amount: { key: 'amount', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'amount', edit: 1 },
            BIOG: { key: 'BIOG', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'BIOG', edit: 1, cssclass: 'amount' },
            gastype: { key: 'gastype', type: 'select', data: Clearing.getTypes, elemkey: 'key', elemvalue: 'value', update: Clearing.updateElement, valCol: 'gastype', printCol: 'gasname', edit: 1 },
            comment: { key: 'comment', type: 'textarea', update: Clearing.updateElement, valCol: 'comment', edit: 1 },      
            actions: { key: 'actions', template: $("#saveform").html() },          
            empty: { key: 'empty', template: ' ' },                
            recompute: function () {
                Clearing.recomputeTotal3($("#upgrade table"));
                recomputeVerbrauch();
            }
        };
        
        var cols = [
            'empty',
            'BIOG',
            'comment',
            'actions'
        ];
        
        var tbl = new Datatable();
        tbl.init("#upgrade table", {
            url: baseurl + '/companies/' + cid + '/periods/' + periodid + '/upgrades',           
            bodysel: '.datacontent',
            idcol: 'id',
            columns: cols,
            model: model,
            okbutton: $("#okbutton").html(),
            datahandler: function (data) {
                // called after data loaded                
                recomputeAndToggle(data, $('#upgrade'));
            }
        });
        return tbl;
    }
    
    function setupHeizgas(baseurl, periodid) {
        var model = {
            rowLabel: "setupHeizgas",
            patchurl: '/api/v1/companies/' + cid + '/heizgas/',
            name: { key: 'name', valCol: 'tid' },
            amount: { key: 'amount', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'amount', edit: 1 },
            BIOG: { key: 'BIOG', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'BIOG', edit: 1, cssclass: 'amount' },
            H: { key: 'H', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'H', edit: 1, cssclass: 'amount' },
            SG: { key: 'SG', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'SG', edit: 1, cssclass: 'amount' },
            IBGN: { key: 'IBGN', type: 'number', cssclass: 'amount', update: Clearing.updateElement, template: printamount, valCol: 'IBGN', edit: 1 },
            IBGZ: { key: 'IBGZ', type: 'number', cssclass: 'amount', update: Clearing.updateElement, template: printamount, valCol: 'IBGZ', edit: 1 },
            LBGM: { key: 'LBGM', type: 'number', cssclass: 'amount', update: Clearing.updateElement, template: printamount, valCol: 'LBGM', edit: 1 },
            LHM: { key: 'LHM',  type: 'number', cssclass: 'amount', update: Clearing.updateElement, template: printamount, valCol: 'LHM', edit: 1 },
            LSGM: { key: 'LSGM',  type: 'number', cssclass: 'amount', update: Clearing.updateElement, template: printamount, valCol: 'LSGM', edit: 1 },
            LBGO: { key: 'LBGO',  type: 'number', cssclass: 'amount', update: Clearing.updateElement, template: printamount, valCol: 'LBGO', edit: 1 },
            LHO: { key: 'LHO',  type: 'number', cssclass: 'amount', update: Clearing.updateElement, template: printamount, valCol: 'LHO', edit: 1  },
            LSGO: { key: 'LSGO',  type: 'number', cssclass: 'amount', update: Clearing.updateElement, template: printamount, valCol: 'LSGO', edit: 1  },
            gastype: { key: 'gastype', type: 'select', data: Clearing.getTypes, elemkey: 'key', elemvalue: 'value', update: Clearing.updateElement, valCol: 'gastype', printCol: 'gasname', edit: 1 },
            totalcol: { key: 'totalcol', type: 'number', min: 0, template: printamount, cssclass: 'amount' },
            comment: { key: 'comment', type: 'textarea', update: Clearing.updateElement, valCol: 'comment', edit: 1 },   
            actions: { key: 'actions', template: $("#saveform").html() },             
            empty: { key: 'empty', template: ' ' },                
            recompute: function () {
                Clearing.recomputeTotal3($("#heizgas table"));
                recomputeVerbrauch();
            }
        };
        
        var cols = [
            'name',
            'BIOG',
            'H',
            'SG',
            'IBGN',
            'IBGZ',
            'LBGM',
            'LHM',
            'LSGM',
            'LBGO',
            'LHO',
            'LSGO',
            'totalcol',
            'comment',
            'actions'
        ];
        
        var tbl = new Datatable();
        tbl.init("#heizgas table", {
            url: baseurl + '/companies/' + cid + '/periods/' + periodid + '/heizgas',           
            bodysel: '.datacontent',
            idcol: 'id',
            columns: cols,
            model: model,
            okbutton: $("#okbutton").html(),
            datahandler: function (data) {
                // called after data loaded                
                recomputeAndToggle(data, $('#heizgas'));
            }
        });
        return tbl;
    }
    
    function setupHeizgasprocess(baseurl, periodid) {
        var model = {
            rowLabel: "setupHeizgasprocess",
            patchurl: '/api/v1/companies/' + cid + '/heizgasprocess/',
            name: { key: 'name', valCol: 'tid' },
            amount: { key: 'amount', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'amount', edit: 1 },
            BIOG: { key: 'BIOG', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'BIOG', edit: 1, cssclass: 'amount' },
            H: { key: 'H', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'H', edit: 1, cssclass: 'amount' },
            SG: { key: 'SG', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'SG', edit: 1, cssclass: 'amount' },
            gastype: { key: 'gastype', type: 'select', data: Clearing.getTypes, elemkey: 'key', elemvalue: 'value', update: Clearing.updateElement, valCol: 'gastype', printCol: 'gasname', edit: 1 },
            totalcol: { key: 'totalcol', type: 'number', min: 0, template: printamount, cssclass: 'amount' },
            comment: { key: 'comment', type: 'textarea', update: Clearing.updateElement, valCol: 'comment', edit: 1 },       
            actions: { key: 'actions', template: $("#saveform").html() },         
            empty: { key: 'empty', template: ' ' },                
            recompute: function () {
                Clearing.recomputeTotal3($("#enaw table"));
                recomputeVerbrauch();
            }
        };
        
        var cols = [
            'name',
            'BIOG',
            'H',
            'SG',
            'totalcol',
            'comment',
            'actions'
        ];
        
        var tbl = new Datatable();
        tbl.init("#enaw table", {
            url: baseurl + '/companies/' + cid + '/periods/' + periodid + '/heizgasprocess',           
            bodysel: '.datacontent',
            idcol: 'id',
            columns: cols,
            model: model,
            okbutton: $("#okbutton").html(),
            datahandler: function (data) {
                // called after data loaded                
                recomputeAndToggle(data, $('#enaw'));
            }
        });
        return tbl;
    }
    
    function setupMuken(baseurl, periodid) {
        var model = {
            rowLabel: "setupMuken",
            patchurl: '/api/v1/companies/' + cid + '/muken/',
            name: { key: 'name', valCol: 'tid' },
            amount: { key: 'amount', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'amount', edit: 1 },
            BIOG: { key: 'BIOG', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'BIOG', edit: 1, cssclass: 'amount' },
            H: { key: 'H', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'H', edit: 1, cssclass: 'amount' },
            SG: { key: 'SG', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'SG', edit: 1, cssclass: 'amount' },
            gastype: { key: 'gastype', type: 'select', data: Clearing.getTypes, elemkey: 'key', elemvalue: 'value', update: Clearing.updateElement, valCol: 'gastype', printCol: 'gasname', edit: 1 },
            comment: { key: 'comment', type: 'textarea', update: Clearing.updateElement, valCol: 'comment', edit: 1 },
            actions: { key: 'actions', template: $("#saveform").html() },
            empty: { key: 'empty', template: ' ' },
            recompute: function () {
                Clearing.recomputeTotal3($("#muken table"));
                recomputeVerbrauch();
            }
        };

        var cols = [
            'name',
            'BIOG',
            'H',
            'SG',
            'comment',
            'actions'
        ];

        var tbl = new Datatable();
        tbl.init("#muken table", {
            url: baseurl + '/companies/' + cid + '/periods/' + periodid + '/muken',
            bodysel: '.datacontent',
            idcol: 'id',
            columns: cols,
            model: model,
            okbutton: $("#okbutton").html(),
            datahandler: function (data) {
                // called after data loaded
                recomputeAndToggle(data, $('#muken'));
            }
        });
        return tbl;
    }

    function setupVerstromung(baseurl, periodid) {
        var model = {
            rowLabel: "setupVerstromung",
            patchurl: '/api/v1/companies/' + cid + '/verstromung/',
            tankstelle: { key: 'tankstelle', valCol: 'tid' },
            amount: { key: 'amount', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'amount', edit: 1 },
            BIOG: { key: 'BIOG', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'BIOG', edit: 1, cssclass: 'amount' },
            H: { key: 'H', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'H', edit: 1, cssclass: 'amount' },
            SG: { key: 'SG', type: 'number', min: 0, update: Clearing.updateElement, template: printamount, valCol: 'SG', edit: 1, cssclass: 'amount' },
            LBGM: { key: 'LBGM', type: 'number',cssclass: 'amount', update: Clearing.updateElement, template: printamount, valCol: 'LBGM', edit: 1},
            LHM: { key: 'LHM', type: 'number',cssclass: 'amount', update: Clearing.updateElement, template: printamount, valCol: 'LHM', edit: 1 },
            LSGM: { key: 'LSGM', type: 'number',cssclass: 'amount', update: Clearing.updateElement, template: printamount, valCol: 'LSGM', edit: 1 },
            gastype: { key: 'gastype', type: 'select', data: Clearing.getTypes, elemkey: 'key', elemvalue: 'value', update: Clearing.updateElement, valCol: 'gastype', printCol: 'gasname', edit: 1 },
            totalcol: { key: 'totalcol', type: 'number', min: 0, template: printamount, cssclass: 'amount' },
            comment: { key: 'comment', type: 'textarea', update: Clearing.updateElement, valCol: 'comment', edit: 1 },   
            actions: { key: 'actions', template: $("#saveform").html() },             
            empty: { key: 'empty', template: ' ' },                
            recompute: function () {
                Clearing.recomputeTotal3($("#strom table"));
                recomputeVerbrauch();
            }
        };
        
        var cols = [
            'tankstelle',
            'BIOG',
            'H',
            'SG',
            'LBGM',
            'LHM',
            'LSGM',
            'totalcol',
            'comment',
            'actions'
        ];
        
        var tbl = new Datatable();
        tbl.init("#strom table", {
            url: baseurl + '/companies/' + cid + '/periods/' + periodid + '/verstromung',           
            bodysel: '.datacontent',
            idcol: 'id',
            columns: cols,
            model: model,
            okbutton: $("#okbutton").html(),
            datahandler: function (data) {
                // called after data loaded                
                recomputeAndToggle(data, $('#strom'));
            }
        });
        return tbl;
    }

    function factreset(key, data) {
        if (data['stdfaktor'] && data['stdfaktor'] > 0) {
            var f = round(data['stdfaktor'], 8);
            return '<img src="/images/icon_reset.gif" class="factorreset" data-stdvalue="' + f + '"/>';
        } else {
            return '';
        }
    }

    function round(number, decimalPlaces) {
        if (typeof number == "string") {
             number = parseFloat(number);
        }
        const factorOfTen = Math.pow(10, decimalPlaces);
        return Math.round( number * factorOfTen) / factorOfTen;
    }

    function checkedit(data) {
        if (data.einheit == 'kg') {
            return false;
        }
        return true;
    }

    function setupZaehler(baseurl, periodid) {
        var model = {
            rowLabel: "setupZaehler",
            patchurl: '/api/v1/companies/' + cid + '/zaehler/',
            name: { key: 'name', valCol: 'name' },
            gastype: {key: 'gastype', valCol: 'gastype'},
            nr: { valCol: 'nr' },
            standalt: { valCol: 'standalt', cssclass: 'amount' },
            einheit: { valCol: 'einheit' },
            stand: { key: 'stand', type: 'number', min: 0, cssclass: 'amount', update: Clearing.updateElement, template: Clearing.printnumber, valCol: 'stand', edit: 1},            
            diff: { cssclass: 'amount' },
            diffkg: { cssclass: 'amount' },
            factor: { key: 'factor', type: 'number', min: 0, step: 'any', cssclass: 'amount', update: Clearing.updateElement, valCol: 'factor', edit: 1, editable: checkedit },
            factoraction: { key: 'factoraction', template: factreset },
            comment: { key: 'comment', type: 'textarea', update: Clearing.updateElement, valCol: 'comment', edit: 1 },   
            actions: { key: 'actions', template: $("#saveform").html() },             
            empty: { key: 'empty', template: ' ' },                
            recompute: function () {
                Clearing.recomputeZaehler($("#zaehler table"));
            }
        };
        
        var cols = [
            'name',
            'nr',            
            'standalt',
            'einheit',
            'stand',
            'einheit',
            'diff',
            'einheit',
            'factor',
            'factoraction',
            'diffkg',
            'comment',
            'actions'            
        ];
        
        var tbl = new Datatable();
        tbl.init("#zaehler table", {
            url: baseurl + '/companies/' + cid + '/periods/' + periodid + '/zaehler',           
            bodysel: '.datacontent',
            idcol: 'id',
            columns: cols,
            model: model,
            okbutton: $("#okbutton").html(),
            datahandler: function (data) {
                // called after data loaded                
                recomputeAndToggle(data, $('#zaehler'));
                if (data.length) {
                    $(".factorreset").click(function (e) {
                        var me = $(this);
                        var stdfactor = me.attr('data-stdvalue');
                        if (stdfactor) {
                            var mid = me.parents('tr').attr('data-id');
                            Clearing.updateElement(model, mid, model.factor, stdfactor, function (err) {
                                if (!err) {
                                    var felem = me.parents('tr').find('.factor');
                                    felem.attr('data-value', stdfactor);
                                    felem.html(stdfactor);
                                    model.recompute();
                                }
                            });
                        }
                    });
                }
            }
        });
        return tbl;
    }

    return {
        init: function (clearing, baseurl, meta) {
            Clearing = clearing;
            periodid = meta.attr('data-period');
            cid = meta.attr('data-company');

            tbls['tankstelle'] = setupTankstelle(baseurl, periodid);
            // disable for now: tbls['fluessigtankstelle'] = setupFluessigtankstelle(baseurl, periodid);
            tbls['upgrade'] = setupUpgrade(baseurl, periodid);
            tbls['heizgas'] = setupHeizgas(baseurl, periodid);
            tbls['enaw'] = setupHeizgasprocess(baseurl, periodid);
            tbls['muken'] = setupMuken(baseurl, periodid);
            tbls['strom'] = setupVerstromung(baseurl, periodid);
            tbls['zaehler'] = setupZaehler(baseurl, periodid);

            Clearing.getSummaryTable(periodid);

            Clearing.getPeriods('handel', function (err, me) {
                // change of period requested
                var pid;
                if (typeof me == 'number') {
                    pid = me;
                } else {
                    pid = me.val();
                }
                periodid = pid;
                var cid = meta.attr('data-company');
                var today = new Date();
                today.setDate(today.getDate() - 1);
                var periods = Clearing.handelperiods();
                var changeuntil = new Date(periods[periodid].changeuntil);
                var tblids = ['tankstelle', /* disable for now: 'fluessigtankstelle',*/ 'upgrade', 'heizgas', 'enaw', 'muken', 'strom', 'zaehler'];
                var tblurls = ['tankstellen', /* disable for now: 'fluessigtankstellen',*/ 'upgrades', 'heizgas', 'heizgasprocess', 'muken', 'verstromung', 'zaehler'];
                if (changeuntil > today) {
                    for (var i = 0; i < tblids.length; i++) {
                        $("#" + tblids[i]).addClass('editable');
                        tbls[tblids[i]].setEditable(true);
                    }
                } else {
                    for (var i = 0; i < tblids.length; i++) {
                        $("#" + tblids[i]).removeClass('editable');
                        tbls[tblids[i]].setEditable(false);;
                    }
                }
                for (var i = 0; i < tblids.length; i++) {                    
                    tbls[tblids[i]].setURL('/api/v1/companies/' + cid + '/periods/' + periodid + '/' + tblurls[i]);
                }
    
                // summary table
                Clearing.getSummaryTable(periodid);
            });
        }
    };
})();
